import React, { Component } from 'react';
import {
  Input,
  Grid
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { parseEditModeFloat } from '../../helpers/inputHelpers';


class ShoeSizeMeasurement extends Component {

  handleChange(event, localMeasurementKey) {
    const { handleModelMeasurementChange, modelMeasurement, measurementKey } = this.props;
    const value = parseEditModeFloat(event.target.value);
    handleModelMeasurementChange(
      {...modelMeasurement, [localMeasurementKey]: value },
      measurementKey
    );
  }

  render() {
    const { measurementKey, modelMeasurement, inEditMode } = this.props;

    return (
      <>
        <Grid container>
          <Grid item xs={2}>US</Grid>
          <Grid item xs={8}>
            <Input
              fullWidth
              value={modelMeasurement[measurementKey]}
              placeholder={0}
              disabled={!inEditMode}
              disableUnderline={!inEditMode}
              onChange={event => this.handleChange(event, measurementKey)
          }
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={2}>EU</Grid>
          <Grid item xs={8}>
            <Input
              fullWidth
              value={modelMeasurement.shoeSizeEU}
              placeholder={0}
              disabled={!inEditMode}
              disableUnderline={!inEditMode}
              onChange={event => this.handleChange(event, 'shoeSizeEU')
          }
            />
          </Grid>
        </Grid>
      </>

    )
  }
}

ShoeSizeMeasurement.propTypes = {
  measurementKey: PropTypes.string.isRequired,
  inEditMode: PropTypes.bool.isRequired,
  modelMeasurement: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any, PropTypes.number, PropTypes.bool])).isRequired,
  handleModelMeasurementChange: PropTypes.func.isRequired,
}

export default ShoeSizeMeasurement;